import { CargoUICase } from '../../../../../business/cargo';
import { useCargoContext } from '../../../context';

export function useHeader() {
  const { setStatus, partnerId } = CargoUICase();

  const {
    setIsOpenDropDown,
    data: { isDropDownOpen },
  } = useCargoContext();

  function openDropDown() {
    setIsOpenDropDown(true);
  }

  function closeDropDown() {
    setIsOpenDropDown(false);
  }

  return {
    isDropDownOpen,
    openDropDown,
    closeDropDown,
    setStatus,
    partnerId,
  };
}
